import { render, staticRenderFns } from "./ReceiptView.vue?vue&type=template&id=50c38d46&scoped=true&"
import script from "./ReceiptView.vue?vue&type=script&lang=js&"
export * from "./ReceiptView.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptView.vue?vue&type=style&index=0&id=50c38d46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c38d46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VChip,VDialog})
